export const RewardInfoQuerys = {
  GET_REWARD_INFO: `    query GetHistoryOrderByCusstomer($input: UserRewardDataInput!, $skip: Float, $take: Float){
      getUserRewardData(input: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            userRewardId
            name
            groupRoleManagementId
            plantId
            groupId
            groupName
            jobTitleCode
            jobName
            signDate
            retireDate
            createId
            createName
            createDate
            modifyId
            modifyName
            modifyDate
            note
            useYn
        }
      }
  }
`,
  SAVE_REWARD_INFO: ``,
  GET_CBX_REWARD_CODE: ``,
  GET_CBX_UNIT: ``,
  GET_CBX_POSITION: ``,
  GET_CBX_EMPLOYEE: `query GetUserReward($input: TuserRewardWhereInput!, $skip: Float!, $take: Float!){
    getUserReward(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            name
        }
    }
}`,
  GET_CBX_OBJECT: ``,
  GET_CBX_GROUP: ``,
  GET_CBX_STATUS: ``,
  // create new user reward
  CREATE_NEW_USER_REWARD: `mutation CreateUserReward($input: TuserRewardInput!){
    createUserReward(input: $input){
        id
        name
        groupRoleManagementId
        jobTitleCode
        plantId
        signDate
        retireDate
        
    }
}`,
  // Update user reward by id
  UPDATE_USER_REWARD_BY_ID: `mutation UpdateUserReward($input: TuserRewardInput!){
    updateUserReward(input: $input){
        id
        name
        groupRoleManagementId
        jobTitleCode
        plantId
        signDate
        retireDate
        
    }
}`,
};
